






















import { Component, Vue, Emit } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';
import { RegionState, Region } from '@/store/region/types';
import { SmartState, Smart } from '@/store/smart/types';
import { IMessage } from '@/store/alert/types';
import Table from '@/components/Table.vue';
import Alert from '@/components/Alert.vue';
import Cards from '@/components/Cards.vue';

const namespace: string = 'smart';

@Component({
  components: {
    Alert,
    Cards,
    Table,
  },
})
export default class ManagementSmartTx extends Vue {
  @State('smart') private smartState?: any;
  @Action('get', { namespace }) private get: () => void;
  @Action('delete', { namespace }) private delete: (
    _id: string,
  ) => Promise<undefined>;
  @Action('add', { namespace }) private add: (
    smart: Smart,
  ) => Promise<undefined>;
  @Action('put', { namespace }) private put: (
    smart: Smart,
  ) => Promise<undefined>;
  @Mutation('alert/SHOW') private alert: (alertMessage: IMessage) => void;
  @Mutation('DATA_DEVICE_CREATE', { namespace }) private dataDeviceCreate: any;
  @Mutation('DATA_DEVICE_CANCEL', { namespace }) private dataDeviceCancel: any;

  canOtherPut: Boolean = true;

  public mounted() {
    this.get();
  }

  public activeCreate() {
    this.dataDeviceCreate();
  }

  public onCreate(value: Smart) {
    let smart = {
      code: value.code!,
      name: value.name,
      enabled: value.enabled,
      phoneNumber: value.phoneNumber,
    };
    if (smart && smart.code !== undefined && smart.name !== undefined) {
      this.add(smart)
        .then(() => {
          this.get();
        })
        .catch(() => {});
    } else {
      this.alert({
        prefix: 'INPUT_',
        error: 'EMPTY',
      });
    }
  }

  public putEvent() {
    this.canOtherPut = false;
  }

  public onPut(value: Smart) {
    let smart = {
      _id: value._id,
      name: value.name,
      enabled: value.enabled,
      phoneNumber: value.phoneNumber,
    };
    if (smart && smart._id !== undefined && smart.name !== undefined) {
      this.put(smart)
        .then(() => {
          this.get();
          this.canOtherPut = true;
        })
        .catch(() => {});
    } else {
      this.alert({
        prefix: 'INPUT_',
        error: 'EMPTY',
      });
    }
  }

  public onDelete(arg: { _id: string }) {
    let conf = confirm('Voulez-vous supprimer ce SmartTx ?');
    if (conf) {
      this.delete(arg._id)
        .then(() => {
          this.get();
        })
        .catch(() => {});
    }
  }

  public onCancel(i: number) {
    this.dataDeviceCancel(i);
  }
}
